import { Flex } from 'foundations-components/components/Flex';
import { Layer } from 'foundations-components/transitional/components/Layer';
import { SATURN_LAYER } from 'foundations-components/transitional/constants';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const LayerWrapperDiv = styled.div.withConfig({
  displayName: "AutosaveAlertsContainer__LayerWrapperDiv"
})(() => {
  return {
    display: 'block',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: SATURN_LAYER
  };
});
const Container = styled.div.withConfig({
  displayName: "AutosaveAlertsContainer__Container"
})(["position:fixed;bottom:", ";left:calc(var(--global-nav-vertical-nav-width) + 16px);z-index:", ";"], props => props.$isSavebarVisible ? '89px' : '16px', Number(SATURN_LAYER) - 1);
const AutosaveAlertsContainer = ({
  children
}) => {
  // Check for the existence of the universal savebar so we can adjust indicator positioning.
  const universalSavebarEl = document.querySelector('[data-test-id="universal-save-bar-sticky-footer"]');
  return /*#__PURE__*/_jsx(Layer, {
    rootNode: document.querySelector('body') || undefined,
    children: /*#__PURE__*/_jsx(LayerWrapperDiv, {
      children: /*#__PURE__*/_jsx(Container, {
        $isSavebarVisible: !!universalSavebarEl,
        children: /*#__PURE__*/_jsx(Flex, {
          gap: "200",
          children: children
        })
      })
    })
  });
};
export default AutosaveAlertsContainer;